import { useEffect, useState } from 'react';
export function useScript(src, initialAttrs) {
    var _a = useState(false), isLoaded = _a[0], setIsLoaded = _a[1];
    useEffect(function () {
        var existedScript = document.querySelector("script[src=\"".concat(src, "\"]"));
        if (existedScript) {
            return;
        }
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = function () {
            setIsLoaded(true);
        };
        if (typeof initialAttrs !== 'undefined') {
            Object.entries(initialAttrs).forEach(function (_a) {
                var attr = _a[0], value = _a[1];
                script.setAttribute(attr, value);
            });
        }
        document.body.appendChild(script);
    }, [src]);
    return { isLoaded: isLoaded };
}
